var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 12.2857,
    fill: "url(#paint0_linear_387_5985)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1186 9.21429H12.6256C10.7417 9.21429 9.21436 10.7415 9.21436 12.6255V31.1185C9.21436 33.0026 10.7416 34.5297 12.6256 34.5297H21.7461L21.7619 25.4837H19.4115C19.106 25.4837 18.8581 25.2366 18.8571 24.9312L18.8456 22.015C18.8444 21.7081 19.0932 21.4584 19.4001 21.4584H21.7464V18.6408C21.7464 15.3711 23.7434 13.5906 26.6602 13.5906H29.0538C29.3599 13.5906 29.6084 13.8389 29.6084 14.1452V16.6039C29.6084 16.9102 29.3601 17.1585 29.0541 17.1585L27.5851 17.1593C25.9989 17.1593 25.6916 17.913 25.6916 19.0194V21.4587H29.1772C29.5096 21.4587 29.7671 21.7488 29.7278 22.0783L29.3822 24.9945C29.3493 25.2737 29.1125 25.4838 28.8315 25.4838H25.7073L25.6915 34.5303H31.1185C33.0024 34.5303 34.5297 33.0029 34.5297 31.119V12.6255C34.5298 10.7416 33.0025 9.21429 31.1186 9.21429Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7458 34.5296L21.7617 25.4835H21.7227V34.5296H21.7458Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_387_5985",
    x1: 21.5,
    y1: 0,
    x2: 21.5,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B73E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2840B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.4853559ce98ef0291de10eef0081d9f7.svg";
export { ForwardRef as ReactComponent };